import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { ReactComponent as Search } from "../assets/images/icons/search/search.svg";
import { inputColor } from "../cssUtils/constants";

const CronSearchInput = ({ updateSearchValue }) => {
    const [query, setQuery] = useState("");

    const handleInputChange = (event) => {
        const value = event.target.value;
        setQuery(value);
        updateSearchValue(value);
    };

    return (
        <TextField
            value={query}
            onChange={handleInputChange}
            placeholder="Search cron name or executed by"
            variant="outlined"
            size="small"
            sx={{
                width: 300,
                "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: 40,
                    fontSize: "14px",
                    color: "#4B5563",
                    "& fieldset": {
                        borderRadius: "8px",
                    },
                },
                "& .MuiOutlinedInput-input": {
                    fontSize: "14px",
                    color: "#4B5563",
                    padding: "10px 0",
                },
                "& .MuiOutlinedInput-input::placeholder": {
                    color: "#6B7280",
                    opacity: 1,
                    fontSize: "14px",
                },
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Search color={inputColor} />
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default CronSearchInput;